/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/helpers/format-money.js":
/*!****************************************!*\
  !*** ./src/js/helpers/format-money.js ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   formatMoney: () => (/* binding */ formatMoney)
/* harmony export */ });
var formatMoney = function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || '${{amount}}';
  function defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ',');
    decimal = defaultTo(decimal, '.');
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
      dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      centsAmount = parts[1] ? decimal + parts[1] : '';
    return dollarsAmount + centsAmount;
  }
  var value = '';
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', '.');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, ',', '.');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
  }
  if (formatString.indexOf('with_comma_separator') !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
};

/***/ }),

/***/ "./src/js/helpers/scroll-to-element.js":
/*!*********************************************!*\
  !*** ./src/js/helpers/scroll-to-element.js ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   scrollToElement: () => (/* binding */ scrollToElement)
/* harmony export */ });
var scrollToElement = function scrollToElement(target, offset) {
  var targetElement;
  if (typeof target === 'string') {
    targetElement = document.querySelector(target);
  } else if (target instanceof HTMLElement) {
    targetElement = target;
  } else {
    console.error('Invalid target: must be a selector string or an HTML element');
    return;
  }
  if (targetElement) {
    // offset for sticky headers
    var yOffset = offset ? offset : 0;
    var y = targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({
      top: y,
      behavior: 'smooth'
    });
  }
};

/***/ }),

/***/ "./src/js/modules/ed-main-order.js":
/*!*****************************************!*\
  !*** ./src/js/modules/ed-main-order.js ***!
  \*****************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var EdMainOrder = /*#__PURE__*/function (_HTMLElement) {
  function EdMainOrder() {
    _classCallCheck(this, EdMainOrder);
    return _callSuper(this, EdMainOrder, arguments);
  }
  _inherits(EdMainOrder, _HTMLElement);
  return _createClass(EdMainOrder, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
      this._initializeFirstItem();
      document.addEventListener('ed:tab-height-update', this.updateTabHeights.bind(this));
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.accordions = this.querySelectorAll('.ed-main-order-item-accordion');
      this.contents = this.querySelectorAll('.ed-main-order-item-content');
      this.buttons = this.querySelectorAll('.ds_button');
      this.tabs = this.querySelectorAll('.ed-order-tabs-wrapper .ed-order-tab-item');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;
      this.accordions.forEach(function (accordion, index) {
        accordion.addEventListener('click', function (event) {
          return _this.handleAccordionClick(event, index);
        });
      });
      this.buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          return _this.handleDsButtonClick(button);
        });
      });
      this.tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          return _this.handleTabClick(tab);
        });
      });
    }
  }, {
    key: "_initializeFirstItem",
    value: function _initializeFirstItem() {
      var firstContent = this.contents[0];
      if (firstContent.classList.contains('expanded')) {
        firstContent.style.maxHeight = firstContent.scrollHeight + 'px';
      }
    }
  }, {
    key: "handleAccordionClick",
    value: function handleAccordionClick(event, index) {
      var targetContent = this.contents[index];
      var isExpanded = targetContent.classList.contains('expanded');
      this.accordions.forEach(function (accordion) {
        return accordion.classList.remove('active-accordion');
      });
      var parentAccordion = event.target.closest('.ed-main-order-item-accordion');
      if (parentAccordion) {
        parentAccordion.classList.add('active-accordion');
      }
      if (!isExpanded) {
        this.contents.forEach(function (content) {
          if (content.classList.contains('expanded')) {
            content.classList.remove('expanded');
            content.style.maxHeight = '0';
          }
        });
        targetContent.classList.add('expanded');
        targetContent.style.maxHeight = targetContent.scrollHeight + 'px';
      }
    }
  }, {
    key: "handleDsButtonClick",
    value: function handleDsButtonClick(button) {
      var targetContent = button.closest('.ed-main-order-item').querySelector('.ed-main-order-item-content');
      var tab = targetContent ? targetContent.querySelector('.ed-order-tabs') : null;
      if (!tab) return;
      var isExpanded = tab.classList.contains('tab-expanded');
      if (isExpanded) {
        tab.classList.remove('tab-expanded');
        tab.style.maxHeight = '0px';
      } else {
        tab.classList.add('tab-expanded');
        tab.style.maxHeight = "".concat(tab.scrollHeight, "px");
      }
      requestAnimationFrame(function () {
        if (targetContent.classList.contains('expanded')) {
          var totalHeight = targetContent.scrollHeight + (isExpanded ? -tab.scrollHeight : tab.scrollHeight);
          if (totalHeight < targetContent.scrollHeight) {
            totalHeight = targetContent.scrollHeight;
          }
          targetContent.style.maxHeight = "".concat(totalHeight, "px");
        }
      });
    }
  }, {
    key: "handleTabClick",
    value: function handleTabClick(tab) {
      var mainOrderItem = tab.closest('.ed-main-order-item');
      var tabs = mainOrderItem.querySelectorAll('.ed-order-tabs-wrapper .ed-order-tab-item');
      var orderTabs = mainOrderItem.querySelectorAll('.ed-order-tab');
      var targetContent = mainOrderItem.querySelector('.ed-main-order-item-content');
      tabs.forEach(function (t) {
        return t.classList.remove('tab-item-active');
      });
      orderTabs.forEach(function (t) {
        t.style.display = 'none';
        t.classList.remove('ed-order-active-tab');
      });
      tab.classList.add('tab-item-active');
      var tabIndex = Array.from(tabs).indexOf(tab);
      if (tabIndex !== -1 && tabIndex < orderTabs.length) {
        var activeTabContent = orderTabs[tabIndex];
        activeTabContent.classList.add('ed-order-active-tab');
        activeTabContent.style.display = 'block';
        requestAnimationFrame(function () {
          if (activeTabContent) {
            var tabsContainer = mainOrderItem.querySelector('.ed-order-tabs');
            if (tabsContainer) {
              tabsContainer.style.maxHeight = "".concat(activeTabContent.scrollHeight, "px");
            }
            if (targetContent.classList.contains('expanded')) {
              var contentHeight = Array.from(targetContent.children).reduce(function (total, child) {
                return total + child.scrollHeight;
              }, 0);
              targetContent.style.maxHeight = "".concat(contentHeight, "px");
            }
          }
        });
      }
    }
  }, {
    key: "updateTabHeights",
    value: function updateTabHeights() {
      var expandedTabs = document.querySelectorAll('.ed-order-tabs.tab-expanded');
      expandedTabs.forEach(function (tab) {
        tab.style.maxHeight = "".concat(tab.scrollHeight + 150, "px");
      });
      var expandedContents = document.querySelectorAll('.ed-main-order-item-content.expanded');
      expandedContents.forEach(function (content) {
        requestAnimationFrame(function () {
          var totalHeight = content.scrollHeight;
          content.style.maxHeight = "".concat(totalHeight, "px");
        });
      });
    }
  }]);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-main-order', EdMainOrder);

/***/ }),

/***/ "./src/js/modules/ed-print-service/ed-print-service-form.js":
/*!******************************************************************!*\
  !*** ./src/js/modules/ed-print-service/ed-print-service-form.js ***!
  \******************************************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var EdPrintServiceForm = /*#__PURE__*/function (_HTMLElement) {
  function EdPrintServiceForm() {
    _classCallCheck(this, EdPrintServiceForm);
    return _callSuper(this, EdPrintServiceForm, arguments);
  }
  _inherits(EdPrintServiceForm, _HTMLElement);
  return _createClass(EdPrintServiceForm, [{
    key: "email",
    get: function get() {
      return this.getAttribute('email');
    }
  }, {
    key: "orderId",
    get: function get() {
      return this.getAttribute('order-id');
    }
  }, {
    key: "product",
    get: function get() {
      return this.getAttribute('product');
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this = this;
      setTimeout(function () {
        _this._attachSelectors();
        _this._attachListeners();
      }, 1000);
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.fileUpload = this.querySelector('input[type="file"]');
      this.submitButton = this.querySelector('[data-btn-submit]');
      this._initAppForm();
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      this.fileUpload.addEventListener('change', this.onFileUploadChange.bind(this));
      this.submitButton.addEventListener('click', this.onBtnSubmit.bind(this));
    }
  }, {
    key: "_initAppForm",
    value: function _initAppForm() {
      this.appForm = document.querySelector('form-embed#app-embed');
      this.appShadowRoot = this.appForm.shadowRoot;
      console.log('app shadow root', this.appShadowRoot);
      this.appEmailInput = this.appShadowRoot.querySelector('input[id="email"]'); // Get the email input
      this.appOrderIdInput = this.appShadowRoot.querySelector('input[id="custom#order_id"]');
      this.appFileInput = this.appShadowRoot.querySelector('input[id="custom#upload-datei-field"]');
      this.appProductInput = this.appShadowRoot.querySelector('input[id="custom#product"]');
      this.appSubmitButton = this.appShadowRoot.querySelector('button[type="submit"]');
      if (this.appEmailInput) {
        this.appEmailInput.value = this.email;
        this.appEmailInput.dispatchEvent(new Event('input', {
          bubbles: true
        }));
      }
      if (this.appOrderIdInput) {
        this.appOrderIdInput.value = this.orderId;
        this.appOrderIdInput.dispatchEvent(new Event('input', {
          bubbles: true
        }));
      }
    }
  }, {
    key: "onBtnSubmit",
    value: function onBtnSubmit(e) {
      var _this2 = this;
      e.preventDefault();
      if (this.appProductInput) {
        this.appProductInput.value = this.product;
        this.appProductInput.dispatchEvent(new Event('input', {
          bubbles: true
        }));
      }

      // submit form
      this.appSubmitButton.click();
      setTimeout(function () {
        var appSuccessMessage = _this2.appShadowRoot.querySelector('[data-testid="banner-success"]');
        if (appSuccessMessage) {
          alert('Datei erfolgreich hochgeladen.');
        } else {
          alert('Ein Fehler ist aufgetreten. Bitte laden Sie die Seite erneut und versuchen Sie es nochmal.');
        }
      }, 2500);
    }
  }, {
    key: "onFileUploadChange",
    value: function onFileUploadChange(e) {
      var files = e.target.files;
      var file = files[0];

      // We cannot set fileInput.value directly due to security restrictions
      // Instead, we create a DataTransfer object to copy the file
      var dataTransfer = new DataTransfer();
      dataTransfer.items.add(file);
      this.appFileInput.files = dataTransfer.files;

      // Simulate user interaction
      this.appFileInput.dispatchEvent(new Event('change', {
        bubbles: true
      }));
      this.appFileInput.dispatchEvent(new Event('input', {
        bubbles: true
      }));
      console.log('File copied to shadow DOM input:', this.appFileInput.files);
    }
  }]);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-print-service-form')) {
  customElements.define('ed-print-service-form', EdPrintServiceForm);
}

/***/ }),

/***/ "./src/js/modules/ed-print-service/ed-print-service-upload.js":
/*!********************************************************************!*\
  !*** ./src/js/modules/ed-print-service/ed-print-service-upload.js ***!
  \********************************************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var PrintServiceUpload = /*#__PURE__*/function (_HTMLElement) {
  function PrintServiceUpload() {
    _classCallCheck(this, PrintServiceUpload);
    return _callSuper(this, PrintServiceUpload, arguments);
  }
  _inherits(PrintServiceUpload, _HTMLElement);
  return _createClass(PrintServiceUpload, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
      this.loadFiles();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.apiUrl = this.getAttribute('api-url');
      this.orderId = this.getAttribute('order-id');
      this.orderNumber = this.getAttribute('order-number');
      this.lineId = this.getAttribute('line-id');
      this.email = this.getAttribute('email');
      this.deleteForm = this.querySelector('#delete-form');
      this.formUpload = this.querySelector('#upload-form');
      this.uploadButton = this.formUpload.querySelector('button[type="submit"]');
      this.formDelete = this.querySelector('#delete-form button');
      this.displayedFile = document.querySelector('.views-field-file .field-content');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;
      this.formDelete.addEventListener('click', function (e) {
        _this.deleteFile(e);
      });
      this.formUpload.addEventListener('submit', this.uploadForm.bind(this));
    }
  }, {
    key: "uploadForm",
    value: function () {
      var _uploadForm = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
        var formData, response, result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              this.uploadButton.disabled = true;
              this.uploadButton.setAttribute('ed-loading', 'true');
              _context.prev = 3;
              formData = new FormData(e.target);
              formData.append('orderId', this.orderId);
              formData.append('orderNumber', this.orderNumber);
              formData.append('lineId', this.lineId);
              formData.append('email', this.email);
              formData.append('apiUrl', this.apiUrl);
              _context.next = 12;
              return fetch(this.apiUrl + '/druckservice/upload', {
                method: 'POST',
                body: formData
              });
            case 12:
              response = _context.sent;
              _context.next = 15;
              return response.json();
            case 15:
              result = _context.sent;
              if (result.success) {
                console.log('File uploaded successfully');
                alert("Datei wurde erfolgreich hochgeladen.");
                this.loadFiles();
              } else {
                console.log('File upload failed: ' + result.error);
              }
              _context.next = 22;
              break;
            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](3);
              console.error('Upload error:', _context.t0);
            case 22:
              _context.prev = 22;
              this.uploadButton.disabled = false;
              this.uploadButton.removeAttribute('ed-loading');
              document.dispatchEvent(new CustomEvent('ed:tab-height-update', {
                bubbles: true
              }));
              return _context.finish(22);
            case 27:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[3, 19, 22, 27]]);
      }));
      function uploadForm(_x) {
        return _uploadForm.apply(this, arguments);
      }
      return uploadForm;
    }()
  }, {
    key: "loadFiles",
    value: function () {
      var _loadFiles = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var response, files;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return fetch("".concat(this.apiUrl, "/druckservice/files/").concat(this.orderId, "/").concat(this.lineId));
            case 2:
              response = _context2.sent;
              _context2.next = 5;
              return response.json();
            case 5:
              files = _context2.sent;
              if (!(files.length === 0 && this.deleteForm)) {
                _context2.next = 12;
                break;
              }
              this.deleteForm.style.display = "none";
              this.changeDisplayedFile(false, false);
              return _context2.abrupt("return");
            case 12:
              this.deleteForm.style.display = "block";
            case 13:
              this.deleteForm.querySelector('.file__name').setAttribute('title', files[0].name);
              this.deleteForm.querySelector('.file__name').textContent = files[0].name;
              this.changeDisplayedFile(files[0].name, "".concat(this.apiUrl).concat(files[0].downloadUrl));
              document.dispatchEvent(new CustomEvent('ed:tab-height-update', {
                bubbles: true
              }));
            case 17:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function loadFiles() {
        return _loadFiles.apply(this, arguments);
      }
      return loadFiles;
    }()
  }, {
    key: "deleteFile",
    value: function () {
      var _deleteFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(e) {
        var response, result;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              e.preventDefault();
              this.formDelete.disabled = true;
              this.formDelete.setAttribute('ed-loading', 'true');
              _context3.next = 5;
              return fetch("".concat(this.apiUrl, "/druckservice/delete/").concat(this.orderId, "/").concat(this.lineId), {
                method: 'DELETE'
              });
            case 5:
              response = _context3.sent;
              _context3.next = 8;
              return response.json();
            case 8:
              result = _context3.sent;
              if (result.success) {
                alert("Datei wurde gelöscht.");
                this.loadFiles();
                this.formDelete.removeAttribute('ed-loading');
                this.formDelete.disabled = false;
              } else {
                console.log('File deletion failed: ' + result.error);
                this.formDelete.removeAttribute('ed-loading');
                this.formDelete.disabled = false;
              }
              return _context3.abrupt("return", result);
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function deleteFile(_x2) {
        return _deleteFile.apply(this, arguments);
      }
      return deleteFile;
    }()
  }, {
    key: "changeDisplayedFile",
    value: function changeDisplayedFile(name, downloadUrl) {
      if (!name && !downloadUrl) {
        this.displayedFile.parentElement.style.display = 'none';
        return;
      }
      this.displayedFile.parentElement.style.display = 'flex';
      this.displayedFile.setAttribute('href', downloadUrl);
      this.displayedFile.textContent = name;
    }
  }]);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-print-service-upload', PrintServiceUpload);

/***/ }),

/***/ "./src/js/modules/ed-product-configurator-media.js":
/*!*********************************************************!*\
  !*** ./src/js/modules/ed-product-configurator-media.js ***!
  \*********************************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var EdProductConfiguratorMedia = /*#__PURE__*/function (_HTMLElement) {
  function EdProductConfiguratorMedia() {
    _classCallCheck(this, EdProductConfiguratorMedia);
    return _callSuper(this, EdProductConfiguratorMedia, arguments);
  }
  _inherits(EdProductConfiguratorMedia, _HTMLElement);
  return _createClass(EdProductConfiguratorMedia, [{
    key: "sectionId",
    get: function get() {
      return this.getAttribute('section-id');
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.featuredImage = this.querySelector('.featured-image');
      this.mainImage = this.querySelector('.main-image');
      this.secondImage = this.querySelector('.second-image');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      document.addEventListener('ed:product-configurator:media-update', this.onItemSelect.bind(this));
      document.addEventListener('ed:product-configurator:nationalfahne-media-update', this.onNationalfahneSelect.bind(this));
    }
  }, {
    key: "onItemSelect",
    value: function onItemSelect(e) {
      var sectionId = e.detail.sectionId;
      var image = e.detail.image;
      var level = e.detail.level;
      if (sectionId !== this.sectionId) {
        return;
      }
      if (!this.featuredImage.classList.contains('hidden')) {
        this.featuredImage.classList.add('hidden');
      }
      if (level === 'Primary') {
        this.updateMainImage(image);
      } else if (level === 'Second') {
        this.updateSecondImage(image);
      }
    }
  }, {
    key: "onNationalfahneSelect",
    value: function onNationalfahneSelect(e) {
      var sectionId = e.detail.sectionId;
      var image = e.detail.image;
      var level = e.detail.level;
      if (sectionId !== this.sectionId) {
        return;
      }
      if (!this.featuredImage.classList.contains('hidden')) {
        this.featuredImage.classList.add('hidden');
      }
      if (level === 'Primary') {
        this.updateMainImage(image);
      } else if (level === 'Second') {
        this.updateSecondImage(image);
      }
    }
  }, {
    key: "updateMainImage",
    value: function updateMainImage(src) {
      this.mainImage.src = src;
    }
  }, {
    key: "updateSecondImage",
    value: function updateSecondImage(src) {
      this.secondImage.src = src;
    }
  }]);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-product-configurator-media', EdProductConfiguratorMedia);

/***/ }),

/***/ "./src/js/modules/ed-product-configurator-product-select.js":
/*!******************************************************************!*\
  !*** ./src/js/modules/ed-product-configurator-product-select.js ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _helpers_scroll_to_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helpers/scroll-to-element */ "./src/js/helpers/scroll-to-element.js");
/* harmony import */ var _helpers_format_money__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helpers/format-money */ "./src/js/helpers/format-money.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }


var ConfigurationStep = /*#__PURE__*/function (_HTMLElement) {
  function ConfigurationStep() {
    _classCallCheck(this, ConfigurationStep);
    return _callSuper(this, ConfigurationStep, arguments);
  }
  _inherits(ConfigurationStep, _HTMLElement);
  return _createClass(ConfigurationStep, [{
    key: "active",
    get: function get() {
      return this.getAttribute('active');
    },
    set: function set(value) {
      return this.setAttribute('active', value);
    }
  }, {
    key: "optionIndex",
    get: function get() {
      return parseInt(this.getAttribute('option-index'));
    }
  }, {
    key: "productId",
    get: function get() {
      return this.getAttribute('product-id');
    }
  }, {
    key: "getHeaderHeight",
    value: function getHeaderHeight() {
      var headerHeight = getComputedStyle(document.documentElement).getPropertyValue('--ed-header-height');
      return parseInt(headerHeight, 10) || 0;
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'active' && newValue === 'true') {
        var _this$selectItems;
        (0,_helpers_scroll_to_element__WEBPACK_IMPORTED_MODULE_0__.scrollToElement)(this.productTitle, -this.getHeaderHeight() - 30);

        // todo: better way
        if (((_this$selectItems = this.selectItems) === null || _this$selectItems === void 0 ? void 0 : _this$selectItems.length) === 0) {
          this.nextStep();
        }
        // todo: better way

        if (this.selectItems) {
          this.updateItemVisibility();
          this.togglePseudoElement();
        }
        this.removeAttribute('latest-step'); // for qty select
      }
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
      if (this.productId) {
        this.selectedProductId = this.productId;
      }
      if (this.selectItems) {
        this.togglePseudoElement();
        this.calculateItemPrices(this, 0);
      }
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.configuratorMain = this.closest('.ed-product-configurator');
      this.configuratorSteps = document.querySelectorAll('[data-configuration-step]');
      this.selectItems = this.querySelectorAll('[data-select-item]');
      this.bntPrevStep = this.querySelectorAll('[data-btn-prev-step]');
      this.btnNextStep = this.querySelectorAll('[data-btn-next-step]');
      this.noSelectWarning = this.querySelector('[data-no-select-warning]');
      this.productTitle = this.configuratorMain.querySelector('[data-cfg-product-title]');
      this.pseudoItem = this.querySelector('.select-item.pseudo');
      if (this.configuratorMain) {
        this.salesTax = this.configuratorMain.getAttribute('sales-tax');
      }
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;
      this.selectItems.forEach(function (item) {
        item.addEventListener('click', _this.onSelectItemClick.bind(_this));
        item.addEventListener('click', _this.updateProductMedia.bind(_this));
      });
      this.bntPrevStep.forEach(function (item) {
        item.addEventListener('click', _this.onBtnPrevStep.bind(_this));
      });
      this.btnNextStep.forEach(function (item) {
        item.addEventListener('click', _this.onBtnNextStep.bind(_this));
      });
    }
  }, {
    key: "onSelectItemClick",
    value: function onSelectItemClick(e) {}
  }, {
    key: "updateProductTitle",
    value: function updateProductTitle(item) {
      var currentProductTitle = this.configuratorMain.buildProductTitle();
      var productTitleContainer = this.configuratorMain.querySelector('[data-cfg-product-title]');
      if (currentProductTitle && productTitleContainer) {
        var title = item.dataset.productTitle;
        productTitleContainer.innerText = currentProductTitle;
        this.currentProductTitle = currentProductTitle;
      }
    }
  }, {
    key: "updateProductMedia",
    value: function updateProductMedia(e) {
      var targetItem = e.target.closest('[data-select-item]');
      document.dispatchEvent(new CustomEvent('ed:product-configurator:media-update', {
        bubbles: true,
        detail: {
          sectionId: this.getAttribute('section-id'),
          image: targetItem.dataset.image,
          level: targetItem.dataset.imageLevel
        }
      }));
    }
  }, {
    key: "updateItemVisibility",
    value: function updateItemVisibility() {
      var _this2 = this;
      this.configuratorMain.cart.forEach(function (cartItem) {
        var _cartItem$selectedIte;
        var excluded = (_cartItem$selectedIte = cartItem.selectedItem) === null || _cartItem$selectedIte === void 0 || (_cartItem$selectedIte = _cartItem$selectedIte.dataset) === null || _cartItem$selectedIte === void 0 ? void 0 : _cartItem$selectedIte.excludedProducts;
        var excludedIds;
        if (excluded) {
          try {
            excludedIds = JSON.parse(excluded).map(function (gid) {
              return gid.split('/').pop();
            });
          } catch (e) {
            console.error("Fehler beim Parsen der excludedProducts:", excluded, e);
          }
        }
        _this2.selectItems.forEach(function (selectItem) {
          var productId = selectItem.dataset.productId;
          if (excludedIds && excludedIds.includes(productId)) {
            selectItem.classList.add('unavailable');
          } else {
            selectItem.classList.remove('unavailable');
          }
        });
      });
    }
  }, {
    key: "updateDynamicInfo",
    value: function updateDynamicInfo() {
      document.dispatchEvent(new CustomEvent('ed:product-configurator:update-dynamic-info'));
    }
  }, {
    key: "onBtnPrevStep",
    value: function onBtnPrevStep() {
      var currentJourney = this.configuratorMain.stepJourney;
      var prevStep = currentJourney[currentJourney.length - 2];
      if (prevStep) {
        this.setAttribute('active', 'false');
        prevStep.setAttribute('active', 'true');
        document.dispatchEvent(new CustomEvent('ed:product-configurator:prev-step', {
          detail: {
            sectionId: this.getAttribute('section-id'),
            nextStep: prevStep
          }
        }));
        this.onStepChange();
      }
    }
  }, {
    key: "onBtnNextStep",
    value: function onBtnNextStep() {
      // show warning if no select
      if (!this.selectedItem) {
        this.noSelectWarning.classList.add('active');
        return;
      }
      document.dispatchEvent(new CustomEvent('ed:product-configurator:add-item', {
        // todo: maybe obsolete because of journey saving
        bubbles: true,
        detail: {
          sectionId: this.getAttribute('section-id'),
          index: this.optionIndex,
          selectedItem: this.selectedItem
        }
      }));

      // now select next element with the same this.selectedItem.dataProductId
      this.nextStep();
      this.onStepChange();
    }
  }, {
    key: "nextStep",
    value: function nextStep() {
      var nextStep = this._findNextStep();
      if (nextStep) {
        this.setAttribute('active', 'false');
        nextStep.setAttribute('active', 'true');
        if (nextStep.classList.contains('ed-configurator-quantity-selector')) {
          this.setAttribute('latest-step', 'true'); // for qty select
        }
        document.dispatchEvent(new CustomEvent('ed:product-configurator:next-step', {
          detail: {
            sectionId: this.getAttribute('section-id'),
            nextStep: nextStep
          }
        }));
      }
    }
  }, {
    key: "onStepChange",
    value: function onStepChange() {
      var currentJourney = this.configuratorMain.stepJourney;
      var currentStep = currentJourney[currentJourney.length - 1];
      console.log('CURRENT STEP', currentStep);

      /** get current cart total **/
      var cartTotal = this._getCartTotal(currentJourney);

      // exception for quantity select
      if (currentStep.classList.contains('ed-configurator-quantity-selector')) {
        //this.calculateItemPrices(currentStep, cartTotal);
        currentStep.onQuantityStepActive(cartTotal);
        return;
      }
      var currentIndex = parseInt(currentStep.getAttribute('option-index'));
      this.calculateItemPrices(currentStep, cartTotal);
      /*
      if (currentIndex >= 2) {
          this.calculateItemPrices(currentStep, cartTotal);
      }
      */
    }
  }, {
    key: "calculateItemPrices",
    value: function calculateItemPrices(currentStep, currentCartTotal) {
      var _this3 = this;
      var items = currentStep.querySelectorAll('.select-item');
      items.forEach(function (item) {
        var price = parseInt(item.dataset.price);
        var priceEl = item.querySelector('[data-calculated-price]');
        var priceMin = currentCartTotal + price;
        if (priceEl) {
          priceEl.innerText = 'ab ' + (0,_helpers_format_money__WEBPACK_IMPORTED_MODULE_1__.formatMoney)(priceMin, '{{ amount_with_comma_separator }} €');
        }

        // first product is sometimes not priced, calc the net prices
        if (price === 0 && _this3.optionIndex === 0) {
          priceMin = item.dataset.minPrice;
        }
        var netPriceEl = item.querySelector('[data-net-price]');
        if (netPriceEl) {
          var salesTaxRate = parseFloat(_this3.salesTax); // Steuer als Dezimalzahl
          var netPrice = priceMin / (1 + salesTaxRate); // Nettopreis berechnen

          netPriceEl.innerText = '(netto ab ' + (0,_helpers_format_money__WEBPACK_IMPORTED_MODULE_1__.formatMoney)(netPrice, '{{ amount_with_comma_separator }} €') + ')';
        }
      });
    }
  }, {
    key: "_getCartTotal",
    value: function _getCartTotal(currentJourney) {
      var cartTotal = 0;
      for (var i = 0; i < currentJourney.length; i++) {
        var _selectedItem$dataset;
        var step = currentJourney[i];
        if (step.getAttribute('active') === 'true') continue;
        var selectedItem = step.querySelector('.select-item.selected');
        if (selectedItem && selectedItem.dataset.hasVariants) {
          continue;
        }
        var selectedItemPrice = parseInt((selectedItem === null || selectedItem === void 0 || (_selectedItem$dataset = selectedItem.dataset) === null || _selectedItem$dataset === void 0 ? void 0 : _selectedItem$dataset.price) || 0);
        cartTotal += selectedItemPrice;
      }
      return cartTotal;
    }

    /** FIND PREV OR NEXT STEP METHODS **/
  }, {
    key: "_findNextStep",
    value: function _findNextStep() {
      var currentMainProductId = this.getAttribute('main-product');
      var currentProductId = this.selectedProductId;
      var currentIndex = this.optionIndex;
      for (var i = 0; i < this.configuratorSteps.length; i++) {
        var step = this.configuratorSteps[i];
        var stepMainProductId = step.getAttribute('main-product');
        var stepProductId = step.getAttribute('product-id');
        var stepOptionIndex = parseInt(step.getAttribute('option-index'));
        if (currentIndex === 0 && stepProductId === currentProductId && stepOptionIndex > currentIndex) {
          return step;
        } else if (currentIndex !== 0 && stepProductId === currentProductId && stepOptionIndex > currentIndex && stepMainProductId === currentMainProductId) {
          return step;
        }
      }

      // if no step found, go to qty select
      var quantitySelectStep = this.configuratorMain.querySelector("ed-configurator-quantity-selector[data-configuration-step][product-id=\"".concat(this.getAttribute('main-product'), "\"]"));
      if (quantitySelectStep) {
        return quantitySelectStep;
      }
      return null;
    }
  }, {
    key: "togglePseudoElement",
    value: function togglePseudoElement() {
      var activeItems = Array.from(this.selectItems).filter(function (item) {
        return !item.classList.contains('unavailable');
      }).length;
      var pseudoDiv = this.pseudoItem;
      if (pseudoDiv) {
        if (activeItems % 2 !== 0) {
          pseudoDiv.classList.add('visible'); // Optional class for styling
        } else {
          pseudoDiv.classList.remove('visible');
        }
      }
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ['active'];
    }
  }]);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-configurator-step', ConfigurationStep);

/**
 *
 * PRODUCT SELECT
 *
 * **/
var ConfiguratorProductSelect = /*#__PURE__*/function (_ConfigurationStep) {
  function ConfiguratorProductSelect() {
    _classCallCheck(this, ConfiguratorProductSelect);
    return _callSuper(this, ConfiguratorProductSelect, arguments);
  }
  _inherits(ConfiguratorProductSelect, _ConfigurationStep);
  return _createClass(ConfiguratorProductSelect, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(ConfiguratorProductSelect.prototype), "connectedCallback", this).call(this);
    }
  }, {
    key: "onSelectItemClick",
    value: function onSelectItemClick(e) {
      var targetItem = e.target.closest('[data-select-item]');
      if (!targetItem.classList.contains('selected')) {
        this.selectItems.forEach(function (item) {
          item.classList.remove('selected');
        });
        targetItem.classList.add('selected');
        this.selectedItem = targetItem;

        /** SET THE SELECTED PRODUCT ID TO FIND THE NEXT STEP **/
        this.selectedProductId = targetItem.dataset.productId;
      }

      // add overlay on the first select
      if (!this.classList.contains('selected')) {
        this.classList.add('selected');
        this.noSelectWarning.classList.remove('active');
      }

      // toggle dynamic info tab // TODO: UPDATE
      this.updateDynamicInfo(this.selectedItem);
      this.updateProductTitle(this.selectedItem);
    }
  }, {
    key: "_findNextStep",
    value: function _findNextStep() {
      // Next step, if product has no variants
      var variantSelect = document.querySelector("ed-configurator-variant-select[data-configuration-step][product-id=\"".concat(this.selectedProductId, "\"]"));
      if (!variantSelect) {
        return _get(_getPrototypeOf(ConfiguratorProductSelect.prototype), "_findNextStep", this).call(this);
      }
      return variantSelect;
    }
  }]);
}(ConfigurationStep);
customElements.define('ed-configurator-product-select', ConfiguratorProductSelect);

/**
 *
 * VARIANT SELECT
 *
 * **/
var ConfiguratorVariantSelect = /*#__PURE__*/function (_ConfigurationStep2) {
  function ConfiguratorVariantSelect() {
    _classCallCheck(this, ConfiguratorVariantSelect);
    return _callSuper(this, ConfiguratorVariantSelect, arguments);
  }
  _inherits(ConfiguratorVariantSelect, _ConfigurationStep2);
  return _createClass(ConfiguratorVariantSelect, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldValue, newValue) {
      _get(_getPrototypeOf(ConfiguratorVariantSelect.prototype), "attributeChangedCallback", this).call(this, name, oldValue, newValue);

      // first variant option is always available, so only check the statuses of the 2nd and 3rd option
      if (this !== this.optionSteps[0] && name === 'active' && newValue === 'true') {
        this.updateVariantStatuses();
        this.checkPseudoElement();
      }
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(ConfiguratorVariantSelect.prototype), "connectedCallback", this).call(this);
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      _get(_getPrototypeOf(ConfiguratorVariantSelect.prototype), "_attachSelectors", this).call(this);
      this.selectedProductId = this.productId;
      this.optionSteps = document.querySelectorAll("[data-configuration-step][product-id=\"".concat(this.productId, "\"]"));
      this.pseudoItem = this.querySelector('.select-item.pseudo');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      _get(_getPrototypeOf(ConfiguratorVariantSelect.prototype), "_attachListeners", this).call(this);
    }
  }, {
    key: "onSelectItemClick",
    value: function onSelectItemClick(e) {
      var targetItem = e.target.closest('[data-select-item]');
      if (!targetItem.classList.contains('selected')) {
        this.selectItems.forEach(function (item) {
          item.classList.remove('selected');
        });
        targetItem.classList.add('selected');
        this.selectedItem = targetItem;
        this.setAttribute('selected-option', targetItem.dataset.optionValue);
      }

      // add overlay on the first select
      if (!this.classList.contains('selected')) {
        this.classList.add('selected');
        this.noSelectWarning.classList.remove('active');
      }

      // toggle dynamic info tab // TODO: UPDATE
      this.updateDynamicInfo(this.selectedItem);
      this.updateProductTitle(this.selectedItem);
    }
  }, {
    key: "updateVariantStatuses",
    value: function updateVariantStatuses(e) {
      var _this4 = this;
      // option1 status rausfinden
      var selectedOptionOne = this.optionSteps[0].getAttribute('selected-option');

      // get all variants with the selected option one
      var selectedOptionOneVariants = this.variantData.filter(function (variant) {
        return selectedOptionOne === variant.option1;
      });
      this.optionSteps.forEach(function (option, index) {
        if (index === 0) return;
        var optionItems = option.querySelectorAll('.select-item[data-option-value]');
        var previousOptionSelected = _this4.optionSteps[index - 1].getAttribute('selected-option');
        var availableOptionInputsValue = selectedOptionOneVariants.filter(function (variant) {
          return variant.available && variant["option".concat(index)] === previousOptionSelected;
        }).map(function (variantOption) {
          return variantOption["option".concat(index + 1)];
        });

        //console.log('available options inputs value', availableOptionInputsValue);

        _this4.setInputAvailability(optionItems, availableOptionInputsValue);
      });
    }
  }, {
    key: "setInputAvailability",
    value: function setInputAvailability(elementList, availableValuesList) {
      elementList.forEach(function (element) {
        var value = element.getAttribute('data-option-value');
        if (availableValuesList.includes(value)) {
          // option is available
          element.classList.remove('unavailable');
        } else {
          // option is not available available
          element.classList.add('unavailable');
        }
      });

      // skip option if there is only one active value
      // TODO: If its prev step, we cannot skip this
      /***
       if (this.active === 'true' && availableValuesList.length === 1) {
       this.selectedItem = this.selectItems[0];
       this.setAttribute('selected-option', this.selectItems[0].dataset.optionValue);
       this.classList.add('selected');
       this.onBtnNextStep();
       }
       **/
    }
  }, {
    key: "checkPseudoElement",
    value: function checkPseudoElement() {
      var availableItems = Array.from(this.selectItems).filter(function (item) {
        return !item.classList.contains('pseudo') && !item.classList.contains('unavailable');
      }).length;
      if (availableItems % 2 !== 0) {
        this.pseudoItem.classList.add('visible');
      } else {
        this.pseudoItem.classList.remove('visible');
      }
    }
  }]);
}(ConfigurationStep);
customElements.define('ed-configurator-variant-select', ConfiguratorVariantSelect);

/*****
 *
 *
 * QUANTITY SELECT
 *
 *
 *****/
var ConfiguratorQuantitySelector = /*#__PURE__*/function (_ConfigurationStep3) {
  function ConfiguratorQuantitySelector() {
    _classCallCheck(this, ConfiguratorQuantitySelector);
    return _callSuper(this, ConfiguratorQuantitySelector, arguments);
  }
  _inherits(ConfiguratorQuantitySelector, _ConfigurationStep3);
  return _createClass(ConfiguratorQuantitySelector, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(ConfiguratorQuantitySelector.prototype), "connectedCallback", this).call(this);
      this.selectItem(this.selectItems[0]);
      //this.setAttribute('active', 'true');

      this.minValue = Array.from(this.selectItems).map(function (item) {
        return parseInt(item.getAttribute('data-value'));
      }).reduce(function (min, value) {
        return Math.min(min, value);
      }, Infinity);
      if (this.getAttribute('quadratmeter-konfigurator') === 'true') {
        this.currentQmLength = 1;
        this.currentQmHeight = 1;
      }
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldValue, newValue) {
      _get(_getPrototypeOf(ConfiguratorQuantitySelector.prototype), "attributeChangedCallback", this).call(this);
      if (name === 'active') {
        if (newValue === 'true') {
          (0,_helpers_scroll_to_element__WEBPACK_IMPORTED_MODULE_0__.scrollToElement)(this.productTitle, -this.getHeaderHeight() - 30);
          this.updatePrice(this.quantityInput.value);
        }
        this.togglePriceElement(newValue);
      }
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      _get(_getPrototypeOf(ConfiguratorQuantitySelector.prototype), "_attachSelectors", this).call(this);
      this.quantityInput = this.querySelector('[data-qty-input]');
      this.btnAddToCart = this.querySelector('[data-btn-add-to-cart]');
      if (this.getAttribute('quadratmeter-konfigurator') === 'true') {
        this.qmLengthInput = this.querySelector('[data-qm-length-input]');
        this.qmHeightInput = this.querySelector('[data-qm-height-input]');
      }
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this5 = this;
      _get(_getPrototypeOf(ConfiguratorQuantitySelector.prototype), "_attachListeners", this).call(this);
      this.quantityInput.addEventListener('input', this.onQuantityInputChange.bind(this));
      this.quantityInput.addEventListener('blur', function (e) {
        return _this5.onInputLeave(e, 'int');
      });
      if (this.getAttribute('quadratmeter-konfigurator') === 'true') {
        this.qmLengthInput.addEventListener('input', this.onQmLengthInputChange.bind(this));
        this.qmLengthInput.addEventListener('blur', function (e) {
          return _this5.onInputLeave(e, 'float');
        });
        this.qmHeightInput.addEventListener('input', this.onQmHeightInputChange.bind(this));
        this.qmHeightInput.addEventListener('blur', function (e) {
          return _this5.onInputLeave(e, 'float');
        });
      }
      this.btnAddToCart.addEventListener('click', this.onBtnAddToCart.bind(this));
      document.addEventListener('ed:product-configurator:quantity-select', this.onQuantityStepActive.bind(this));
    }
  }, {
    key: "onSelectItemClick",
    value: function onSelectItemClick(e) {
      var targetItem = e.target.closest('[data-select-item]');
      this.selectItem(targetItem);
    }
  }, {
    key: "selectItem",
    value: function selectItem(targetItem) {
      if (!targetItem.classList.contains('selected')) {
        this.selectItems.forEach(function (item) {
          item.classList.remove('selected');
        });
        targetItem.classList.add('selected');
        this.selectedItem = targetItem;
        this.quantityInput.value = targetItem.dataset.value;
        this.changeQuantity(targetItem.dataset.value);
        this.updatePrice(targetItem.dataset.value);
      }
    }
  }, {
    key: "onQuantityStepActive",
    value: function onQuantityStepActive(cartTotal) {
      var _this6 = this;
      if (this.configuratorMain && this.configuratorMain.getAttribute('nationalfahnen-select')) {
        // get total price from nationalfahne
        var cart = this.configuratorMain.cart;
        cartTotal = cart[cart.length - 1].selectedItem.dataset.price;
      }
      var showUnitPrice = this.getAttribute('show-unit-price') === 'true';

      // update select item prices
      this.selectItems.forEach(function (item) {
        var quantityValue = parseInt(item.dataset.value);
        var discount = parseFloat(item.dataset.discount || 0);
        var unitPrice = cartTotal * (1 - discount / 100);
        var totalPrice = unitPrice * quantityValue;
        var displayPrice = showUnitPrice ? unitPrice : totalPrice;
        var priceEl = item.querySelector('[data-calculated-price]');
        if (priceEl) {
          priceEl.innerText = (showUnitPrice ? "" : "ab ") + (0,_helpers_format_money__WEBPACK_IMPORTED_MODULE_1__.formatMoney)(displayPrice, '{{ amount_with_comma_separator }} €');
        }

        // calculate netPrice
        var netPriceEl = item.querySelector('[data-net-price]');
        if (netPriceEl) {
          var salesTaxRate = parseFloat(_this6.salesTax);
          var netPrice = displayPrice / (1 + salesTaxRate);
          netPriceEl.innerText = '(netto ' + (showUnitPrice ? "" : "ab ") + (0,_helpers_format_money__WEBPACK_IMPORTED_MODULE_1__.formatMoney)(netPrice, '{{ amount_with_comma_separator }} €') + ')';
        }
      });

      // todo
    }
  }, {
    key: "onBtnAddToCart",
    value: function onBtnAddToCart(e) {
      var _this$qmLengthInput, _this$qmHeightInput;
      document.dispatchEvent(new CustomEvent('ed:product-configurator:add-to-cart', {
        bubbles: true,
        detail: {
          sectionId: this.getAttribute('section-id'),
          mainProductId: this.getAttribute('main-product'),
          productId: this.getAttribute('product-id'),
          quantity: this.quantityInput.value,
          qmLength: (_this$qmLengthInput = this.qmLengthInput) === null || _this$qmLengthInput === void 0 ? void 0 : _this$qmLengthInput.value,
          qmHeight: (_this$qmHeightInput = this.qmHeightInput) === null || _this$qmHeightInput === void 0 ? void 0 : _this$qmHeightInput.value
        }
      }));
    }
  }, {
    key: "onQuantityInputChange",
    value: function onQuantityInputChange(e) {
      var rawValue = e.target.value.trim();

      // Wenn Feld leer ist, nichts tun – aber nicht blockieren
      if (rawValue === '') {
        return;
      }
      var integerCheck = /^\d+$/;
      if (!integerCheck.test(rawValue)) {
        e.target.value = this.currentQuantity || this.minValue;
        return;
      }
      var newQuantity = parseInt(rawValue, 10);

      // Wenn kleiner als Mindestwert → zurücksetzen auf Mindestwert
      if (newQuantity < this.minValue) {
        newQuantity = this.minValue;
        e.target.value = this.minValue;
      }
      this.changeQuantity(newQuantity);
      this.updatePrice(newQuantity);
    }
  }, {
    key: "changeQuantity",
    value: function changeQuantity(qty) {
      this.setAttribute('current-qty', qty);
      this.currentQuantity = parseInt(qty);
    }
  }, {
    key: "getDiscountForQuantity",
    value: function getDiscountForQuantity(qty) {
      var discount = 0;
      var closestQty = -1;
      this.selectItems.forEach(function (item) {
        var itemQty = parseInt(item.dataset.value);
        if (qty >= itemQty && itemQty > closestQty) {
          closestQty = itemQty;
          discount = parseFloat(item.dataset.discount || 0);
        }
      });
      return discount;
    }
  }, {
    key: "updatePrice",
    value: function updatePrice(qty) {
      var _this7 = this;
      var cart = this.configuratorMain.cart;
      var cartCopy = _toConsumableArray(cart);
      qty = parseInt(qty);
      var price = 0;
      if (this.configuratorMain.getAttribute('nationalfahnen-select')) {
        cartCopy.shift(); // remove first item on nationalfahnen select
      }
      cartCopy.forEach(function (cartItem) {
        price += parseInt(cartItem.selectedItem.dataset.price);
        if (_this7.getAttribute('quadratmeter-konfigurator') === 'true') {
          price = parseInt(cartItem.selectedItem.dataset.price) / 2 * parseFloat(_this7.qmLengthInput.value) * parseFloat(_this7.qmHeightInput.value) * 2;
        }
      });
      var discount = this.getDiscountForQuantity(qty);
      var finalPrice = price * (1 - discount / 100) * qty;
      this.configuratorMain.priceElement.innerText = (0,_helpers_format_money__WEBPACK_IMPORTED_MODULE_1__.formatMoney)(finalPrice, '{{ amount_with_comma_separator }} €');
    }
  }, {
    key: "togglePriceElement",
    value: function togglePriceElement(value) {
      var priceElement = this.configuratorMain.priceElement;
      if (value === 'true') {
        priceElement.classList.add('visible');
      } else {
        priceElement.classList.remove('visible');
      }
    }
  }, {
    key: "onQmLengthInputChange",
    value: function onQmLengthInputChange(e) {
      var rawValue = e.target.value.trim();
      if (rawValue === '') {
        return;
      }
      var stepValue = 0.1;
      var minValue = 1;
      var decimalCheck = /^-?\d+(\.\d{0,1})?$/;
      if (!decimalCheck.test(rawValue)) {
        console.log('Ist schlecht', this.currentQmLength);
        this.changeLength(this.currentQmLength);
        e.target.value = this.currentQmLength;
        this.updatePrice(this.currentQuantity);
        return;
      }
      var newLength = parseFloat(rawValue);
      if (isNaN(newLength) || newLength < minValue || !this.isStepValid(newLength, stepValue)) {
        return;
      }
      this.changeLength(newLength);
      this.updatePrice(this.currentQuantity);
    }
  }, {
    key: "changeLength",
    value: function changeLength(qty) {
      this.currentQmLength = parseFloat(qty);
    }
  }, {
    key: "onQmHeightInputChange",
    value: function onQmHeightInputChange(e) {
      var rawValue = e.target.value.trim();
      if (rawValue === '') {
        return;
      }
      var stepValue = 0.1;
      var minValue = 1;
      var decimalCheck = /^-?\d+(\.\d{0,1})?$/;
      if (!decimalCheck.test(rawValue)) {
        this.changeHeight(this.currentQmHeight);
        e.target.value = this.currentQmHeight;
        this.updatePrice(this.currentQuantity);
        return;
      }
      var newHeight = parseFloat(rawValue);
      if (isNaN(newHeight) || newHeight < minValue || !this.isStepValid(newHeight, stepValue)) {
        return;
      }
      this.changeHeight(newHeight);
      this.updatePrice(this.currentQuantity);
    }
  }, {
    key: "isStepValid",
    value: function isStepValid(value, step) {
      return Math.abs(Math.round(value / step) * step - value) < 0.0001;
    }
  }, {
    key: "changeHeight",
    value: function changeHeight(qty) {
      this.currentQmHeight = parseFloat(qty);
    }
  }, {
    key: "onInputLeave",
    value: function onInputLeave(e) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'int';
      var input = e.target;
      var rawValue = input.value.trim();
      var value;
      if (type === 'float') {
        value = parseFloat(rawValue);
      } else {
        value = parseInt(rawValue, 10);
      }
      if (isNaN(value) || value < 1) {
        input.value = 1;
        if (input === this.quantityInput) {
          this.changeQuantity(1);
          this.updatePrice(1);
        }
        if (input === this.qmLengthInput) {
          this.changeLength(1);
          this.updatePrice(this.currentQuantity);
        }
        if (input === this.qmHeightInput) {
          this.changeHeight(1);
          this.updatePrice(this.currentQuantity);
        }
      }
    }
  }]);
}(ConfigurationStep);
customElements.define('ed-configurator-quantity-selector', ConfiguratorQuantitySelector);

/*****
 *
 *
 * NATIONAL FLAGS SELECT
 *
 *
 *****/
var ConfiguratorNationalfahnenSelect = /*#__PURE__*/function (_ConfigurationStep4) {
  function ConfiguratorNationalfahnenSelect() {
    _classCallCheck(this, ConfiguratorNationalfahnenSelect);
    return _callSuper(this, ConfiguratorNationalfahnenSelect, arguments);
  }
  _inherits(ConfiguratorNationalfahnenSelect, _ConfigurationStep4);
  return _createClass(ConfiguratorNationalfahnenSelect, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(ConfiguratorNationalfahnenSelect.prototype), "connectedCallback", this).call(this);
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      _get(_getPrototypeOf(ConfiguratorNationalfahnenSelect.prototype), "_attachSelectors", this).call(this);
      this.input = this.querySelector('input');
      this.countryList = this.querySelector('.country-list');
      this.countrySelectItems = this.querySelectorAll('[data-country-select-item]');
      this.selectItems = this.countrySelectItems; // needed for attribute changed callback
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this8 = this;
      _get(_getPrototypeOf(ConfiguratorNationalfahnenSelect.prototype), "_attachListeners", this).call(this);
      this.input.addEventListener('input', this.onInputChange.bind(this));
      this.countrySelectItems.forEach(function (item) {
        item.addEventListener('click', _this8.onCountrySelectItemClick.bind(_this8));
      });

      // Check if the click happened outside the component
      document.addEventListener('click', this.onDocumentClick.bind(this));
    }
  }, {
    key: "onDocumentClick",
    value: function onDocumentClick(event) {
      if (!this.contains(event.target)) {
        this.countryList.classList.remove('visible');
      }
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(e) {
      this.filterCountryList(e.target.value);
      this.countryList.classList.add('visible');
    }
  }, {
    key: "onCountrySelectItemClick",
    value: function onCountrySelectItemClick(e) {
      //super.onSelectItemClick(e);
      var targetItem = e.target.closest('[data-country-select-item]');
      if (targetItem) {
        this.input.value = e.target.dataset.value;
        this.countryList.classList.remove('visible');
        this.selectedCountry = _objectSpread({}, e.target.dataset);

        //this.selectedItem = targetItem;
        this.selectItem(this.selectedCountry);
      }
    }
  }, {
    key: "selectItem",
    value: function selectItem(item) {
      var _this$closest;
      var currentCart = (_this$closest = this.closest('.ed-product-configurator')) === null || _this$closest === void 0 ? void 0 : _this$closest.cart;
      var selectedVariantIndex = parseInt(currentCart[0].selectedItem.dataset.variantIndex, 10);
      var priceClass = parseInt(item.priceClass, 10);
      var priceClassProducts = JSON.parse(this.getAttribute('price-class-products') || '[]');
      var selectedPriceClassProduct = priceClassProducts[priceClass - 1];
      var selectedPriceClassVariant = selectedPriceClassProduct.variants[selectedVariantIndex - 1];
      this.selectedItem = {
        dataset: {
          value: selectedPriceClassVariant.id,
          country: item.value,
          masterProductId: this.getAttribute('master-product'),
          price: selectedPriceClassVariant.price,
          productTitle: item.value
        }
      };
      this.updateProductMedia(item);
      this.noSelectWarning.classList.remove('active');
    }
  }, {
    key: "updateProductMedia",
    value: function updateProductMedia(item) {
      document.dispatchEvent(new CustomEvent('ed:product-configurator:nationalfahne-media-update', {
        bubbles: true,
        detail: {
          sectionId: this.getAttribute('section-id'),
          image: item.image,
          level: 'Second'
        }
      }));
    }
  }, {
    key: "filterCountryList",
    value: function filterCountryList(searchQuery) {
      var normalizedQuery = searchQuery.toLowerCase();

      // Filter country list based on the search query
      this.countrySelectItems.forEach(function (item) {
        var countryValue = item.dataset.value.toLowerCase();
        if (countryValue.includes(normalizedQuery)) {
          item.classList.remove('hidden'); // Show matching items
        } else {
          item.classList.add('hidden'); // Hide non-matching items
        }
      });
    }
  }]);
}(ConfigurationStep);
customElements.define('ed-configurator-nationalfahnen-select', ConfiguratorNationalfahnenSelect);

/***/ }),

/***/ "./src/js/modules/ed-product-configurator.js":
/*!***************************************************!*\
  !*** ./src/js/modules/ed-product-configurator.js ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _helpers_scroll_to_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helpers/scroll-to-element */ "./src/js/helpers/scroll-to-element.js");
/* harmony import */ var _ed_product_configurator_product_select__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./ed-product-configurator-product-select */ "./src/js/modules/ed-product-configurator-product-select.js");
/* harmony import */ var _ed_product_configurator_media__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./ed-product-configurator-media */ "./src/js/modules/ed-product-configurator-media.js");
/* harmony import */ var _ed_product_configurator_media__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_ed_product_configurator_media__WEBPACK_IMPORTED_MODULE_2__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }



var EdProductConfigurator = /*#__PURE__*/function (_HTMLElement) {
  function EdProductConfigurator() {
    _classCallCheck(this, EdProductConfigurator);
    return _callSuper(this, EdProductConfigurator);
  }
  _inherits(EdProductConfigurator, _HTMLElement);
  return _createClass(EdProductConfigurator, [{
    key: "active",
    get: function get() {
      return this.getAttribute('active');
    },
    set: function set(value) {
      return this.setAttribute('active', value);
    }
  }, {
    key: "sectionId",
    get: function get() {
      return this.getAttribute('section-id');
    }
  }, {
    key: "salesTax",
    get: function get() {
      return this.getAttribute('sales-tax');
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this.isNationalfahne = this.getAttribute('nationalfahnen-select');
      this._attachSelectors();
      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.stepJourney = [];
      this.cart = [];
      this.configuratorSteps = document.querySelectorAll('[data-configuration-step]');
      this.priceElement = this.querySelector('[data-calc-price]');
      this.stepJourney.push(this.configuratorSteps[0]);
      this.productTitle = this.querySelector('[data-cfg-product-title]');
      this.postPurchasePopup = this.querySelector('.ed-post-purchase-popup');
      this.postPurchaseOverlay = this.querySelector('.ed-post-purchase-overlay');
      this.postPurchaseCloseButton = this.querySelector('.ed-post-purchase-popup__close-button');
      this.productTitleElement = this.querySelector('.ed-post-purchase-popup__product-title');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;
      document.addEventListener('ed:product-configurator:next-step', this.onNextStep.bind(this));
      document.addEventListener('ed:product-configurator:prev-step', this.onPrevStep.bind(this));
      document.addEventListener('ed:product-configurator:add-to-cart', this.onAddToCart.bind(this));
      document.addEventListener('ed:product-configurator:add-item', this.onAddItem.bind(this));
      document.addEventListener('ed:product-configurator:update-dynamic-info', this.onUpdateDynamicInfo.bind(this));
      if (this.postPurchaseCloseButton) {
        this.postPurchaseCloseButton.addEventListener('click', function () {
          return _this.closePostPurchasePopup();
        });
      }
    }
  }, {
    key: "onNextStep",
    value: function onNextStep(e) {
      var sectionId = e.detail.sectionId;
      var nextStep = e.detail.nextStep;
      if (sectionId !== this.sectionId) {
        return;
      }
      if (nextStep) {
        this.stepJourney.push(nextStep); // Add the next step to the journey array
      }
      this.onUpdateDynamicInfo();
      this.updateProductTitle();
    }
  }, {
    key: "onPrevStep",
    value: function onPrevStep(e) {
      var sectionId = e.detail.sectionId;
      if (sectionId !== this.sectionId) {
        return;
      }
      if (this.stepJourney.length > 0) {
        this.stepJourney.pop(); // Remove the last step from the journey array
      }
      this.onUpdateDynamicInfo();
    }
  }, {
    key: "buildProductTitle",
    value: function buildProductTitle() {
      var newProductTitle = this.getAttribute('base-title') + ' ';
      console.log('step journey', this.stepJourney);
      this.stepJourney.forEach(function (step) {
        if (step.selectedItem) {
          newProductTitle += step.selectedItem.dataset.productTitle + ' ';
        }
      });
      return newProductTitle;
    }
  }, {
    key: "updateProductTitle",
    value: function updateProductTitle() {
      var newProductTitle = this.getAttribute('base-title') + ' ';
      this.stepJourney.forEach(function (step) {
        if (step.selectedItem && !step.classList.contains('ed-configurator-quantity-selector')) {
          newProductTitle += step.selectedItem.dataset.productTitle + ' ';
        }
      });
      this.productTitle.innerText = newProductTitle;
    }
  }, {
    key: "onUpdateDynamicInfo",
    value: function onUpdateDynamicInfo() {
      document.dispatchEvent(new CustomEvent('ed:product-configurator:dispatch-journey', {
        detail: {
          stepJourney: this.stepJourney
        }
      }));
    }
  }, {
    key: "onAddItem",
    value: function onAddItem(e) {
      // todo: maybe obsolete because of journey saving
      var sectionId = e.detail.sectionId;
      var selectedItem = e.detail.selectedItem;
      var optionIndex = e.detail.index;
      if (sectionId !== this.sectionId) {
        return;
      }

      // Find the index of the item with the same optionIndex
      var itemIndex = this.cart.findIndex(function (item) {
        return item.optionIndex === optionIndex;
      });
      if (itemIndex !== -1) {
        // Replace the existing item
        this.cart[itemIndex] = {
          sectionId: sectionId,
          selectedItem: selectedItem,
          optionIndex: optionIndex
        };
      } else {
        // Add the new item
        this.cart.push({
          sectionId: sectionId,
          selectedItem: selectedItem,
          optionIndex: optionIndex
        });
      }

      // Remove items with a greater optionIndex
      this.cart = this.cart.filter(function (item) {
        return item.optionIndex <= optionIndex;
      });
    }
  }, {
    key: "onAddToCart",
    value: function onAddToCart(e) {
      var sectionId = e.detail.sectionId;
      var mainProductId = e.detail.mainProductId;
      var productId = e.detail.productId;
      var quantity = e.detail.quantity;
      var qmLength = e.detail.qmLength;
      var qmHeight = e.detail.qmHeight;
      if (sectionId !== this.sectionId) {
        return;
      }

      // Create a local copy of the cart and remove first item if needed
      var cartCopy = _toConsumableArray(this.cart);
      if (this.isNationalfahne) {
        cartCopy.shift(); // Removes the first item
      }
      var qmProduct = this.getAttribute('quadratmeter-konfigurator') === 'true';
      if (this.getAttribute('quadratmeter-konfigurator') !== 'true') {
        this.addToCart(cartCopy, parseInt(quantity));
      } else {
        this.addQmProductToCart(cartCopy, parseInt(quantity), qmLength, qmHeight);
      }
    }
  }, {
    key: "addToCart",
    value: function addToCart(cart, quantity) {
      var _this2 = this;
      this.setAttribute('ed-loading', 'true');
      console.log('ATC', cart);
      var edBundleId = new Date().getTime();
      var items = [];
      var wrapperElements = this.querySelectorAll('.configurator-wrapper.selected');
      var bundleTitle = wrapperElements[wrapperElements.length - 1].currentProductTitle;
      if (parseInt(cart[0].selectedItem.dataset.price) === 0 && !this.isNationalfahne) {
        cart = cart.slice(1); // skip the first item
      }
      cart.forEach(function (product) {
        if (product.selectedItem.dataset.value) {
          var item = {
            id: product.selectedItem.dataset.value,
            quantity: quantity,
            properties: {
              '_masterProductId': _this2.getAttribute('master-product-id'),
              '_bundleId': edBundleId,
              '_bundleTitle': bundleTitle,
              '_configurator-product': true
            }
          };

          // Add country property if it exists
          if (product.selectedItem.dataset.country) {
            item.properties['Land'] = product.selectedItem.dataset.country;
          }
          items.push(item);
        }
      });
      var formData = {
        'items': items
      };
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      }).then(function (response) {
        _this2.openPostPurchasePopup();
        _this2.removeAttribute('ed-loading');
        return response.json();
      })["catch"](function (error) {
        console.error('Error:', error);
      });
    }
  }, {
    key: "addQmProductToCart",
    value: function addQmProductToCart(cart, quantity, qmLength, qmHeight) {
      var _this3 = this;
      this.setAttribute('ed-loading', 'true');
      var edBundleId = new Date().getTime();
      var items = [];
      var wrapperElements = this.querySelectorAll('.configurator-wrapper.selected');
      var bundleTitle = wrapperElements[wrapperElements.length - 1].currentProductTitle;
      if (parseInt(cart[0].selectedItem.dataset.price) === 0 && !this.isNationalfahne) {
        cart = cart.slice(1); // skip the first item
      }
      cart.forEach(function (product, index) {
        if (product.selectedItem.dataset.value) {
          if (product.selectedItem.dataset.productPerQm) {
            /** ADD PRICE PER QM PRODUCT **/
            var qmQuantity = quantity * qmLength * qmHeight * 10;
            qmHeight = parseFloat(qmHeight).toFixed(2);
            qmLength = parseFloat(qmLength).toFixed(2);
            var item = {
              id: product.selectedItem.dataset.productPerQm,
              quantity: Math.round(qmQuantity),
              properties: {
                '_masterProductId': _this3.getAttribute('master-product-id'),
                '_bundleId': edBundleId,
                '_bundleTitle': bundleTitle,
                '_configurator-product': true,
                'Anzahl': quantity,
                'Hoehe': qmHeight.replace('.', ','),
                'Laenge': qmLength.replace('.', ',')
              }
            };
            items.push(item);
          }
        }
      });
      var formData = {
        'items': items
      };
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      }).then(function (response) {
        _this3.openPostPurchasePopup();
        _this3.removeAttribute('ed-loading');
        return response.json();
      })["catch"](function (error) {
        console.error('Error:', error);
      });
    }
  }, {
    key: "openPostPurchasePopup",
    value: function openPostPurchasePopup() {
      var _this4 = this;
      if (!document.body.contains(this.postPurchasePopup)) {
        document.body.appendChild(this.postPurchasePopup);
      }
      if (this.postPurchaseOverlay.parentNode !== document.body) document.body.appendChild(this.postPurchaseOverlay);
      if (this.postPurchasePopup.parentNode !== document.body) document.body.appendChild(this.postPurchasePopup);
      if (this.productTitleElement) {
        var newProductTitle = this.getAttribute('base-title') + ' ';
        this.stepJourney.forEach(function (step) {
          if (step.selectedItem && !step.classList.contains('ed-configurator-quantity-selector')) {
            newProductTitle += step.selectedItem.dataset.productTitle + ' ';
          }
        });
        this.productTitleElement.innerText = newProductTitle;
      }
      requestAnimationFrame(function () {
        _this4.postPurchaseOverlay.classList.add('open');
        _this4.postPurchasePopup.classList.add('open');
      });
    }
  }, {
    key: "closePostPurchasePopup",
    value: function closePostPurchasePopup() {
      var _this5 = this;
      requestAnimationFrame(function () {
        _this5.postPurchaseOverlay.classList.remove('open');
        _this5.postPurchasePopup.classList.remove('open');
        window.location.reload();
      });
    }
  }]);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-product-configurator', EdProductConfigurator);

/***/ }),

/***/ "./src/js/modules/ed-product-tab-dynamic-info.js":
/*!*******************************************************!*\
  !*** ./src/js/modules/ed-product-tab-dynamic-info.js ***!
  \*******************************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var EdProductTabDynamicInfo = /*#__PURE__*/function (_HTMLElement) {
  function EdProductTabDynamicInfo() {
    _classCallCheck(this, EdProductTabDynamicInfo);
    return _callSuper(this, EdProductTabDynamicInfo, arguments);
  }
  _inherits(EdProductTabDynamicInfo, _HTMLElement);
  return _createClass(EdProductTabDynamicInfo, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.dynamicInfoContainer = this.querySelector('.dynamic-short-info-container');
      this.tableItems = this.querySelector('[data-dynamic-table-items]');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      document.addEventListener('ed:product-configurator:dispatch-journey', this.updateDynamicInfo.bind(this));
    }
  }, {
    key: "updateDynamicInfo",
    value: function updateDynamicInfo(e) {
      var _this = this;
      var stepJourney = e.detail.stepJourney;

      // Clear the table before updating with new information
      this.tableItems.innerHTML = '';
      stepJourney.forEach(function (step) {
        var selectedItem = step.querySelector('.selected');
        if (selectedItem) {
          var shortInfo = selectedItem.querySelector('.dynamic-short-info');
          if (shortInfo) {
            shortInfo = JSON.parse(shortInfo.innerText);
            shortInfo = shortInfo.reverse();
            shortInfo.forEach(function (item) {
              // Split the string by "||"
              var values = item.split('||').map(function (value) {
                return value.trim();
              });

              // Create the row div
              var rowDiv = document.createElement('div');
              rowDiv.className = 'row';

              // Create div elements for each value and append to the row
              values.forEach(function (value) {
                var valueDiv = document.createElement('div');
                valueDiv.textContent = value;
                rowDiv.appendChild(valueDiv);
              });

              // Insert the row at the top of the container (rows are added in reverse order)
              if (_this.tableItems.firstChild) {
                _this.tableItems.insertBefore(rowDiv, _this.tableItems.firstChild);
              } else {
                _this.tableItems.appendChild(rowDiv); // Fallback if there is no child
              }
            });
          }
        }
      });

      // Check if the tableItems has any content and set aria-hidden accordingly
      if (this.tableItems.children.length > 0) {
        this.dynamicInfoContainer.setAttribute('aria-hidden', 'false');
      } else {
        this.dynamicInfoContainer.setAttribute('aria-hidden', 'true');
      }
    }
  }]);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-product-tab-dynamic-info', EdProductTabDynamicInfo);

/***/ }),

/***/ "./src/js/modules/ed-product-tabs.js":
/*!*******************************************!*\
  !*** ./src/js/modules/ed-product-tabs.js ***!
  \*******************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var EdProductTabs = /*#__PURE__*/function (_HTMLElement) {
  function EdProductTabs() {
    _classCallCheck(this, EdProductTabs);
    return _callSuper(this, EdProductTabs, arguments);
  }
  _inherits(EdProductTabs, _HTMLElement);
  return _createClass(EdProductTabs, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.tabSelectItems = this.querySelectorAll('[role="tab"][aria-controls]');
      this.tabContentItems = this.querySelectorAll('[data-content-item]');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;
      this.tabSelectItems.forEach(function (item) {
        item.addEventListener('click', _this.onTabItemClick.bind(_this));
      });
    }
  }, {
    key: "onTabItemClick",
    value: function onTabItemClick(e) {
      var target = e.currentTarget;
      this.toggleItems(target);
    }
  }, {
    key: "toggleItems",
    value: function toggleItems(target) {
      this.tabSelectItems.forEach(function (item) {
        item.setAttribute('aria-expanded', 'false');
        if (item === target) {
          item.setAttribute('aria-expanded', 'true');
        }
      });
      this.tabContentItems.forEach(function (item) {
        item.setAttribute('aria-hidden', 'true');
        var attribute = target.getAttribute('aria-controls');
        if (item.id === attribute) {
          item.setAttribute('aria-hidden', 'false');
        }
      });
    }
  }]);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-product-tabs', EdProductTabs);

/***/ }),

/***/ "./src/js/modules/ed-product-upsells.js":
/*!**********************************************!*\
  !*** ./src/js/modules/ed-product-upsells.js ***!
  \**********************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
/*
 * Upsell slider (sections/ed-product-upsells.liquid).
 *
 * Dawn's SliderComponent (global.js) moves one slide per arrow click. Upsells show
 * several cards side by side, so one click should move a whole page — like the
 * slideshow on the homepage. SliderComponent reads `data-step` from the clicked
 * button; this element keeps that attribute in sync with the number of cards that
 * are currently visible (which changes with the breakpoint).
 */
var EdProductUpsells = /*#__PURE__*/function (_HTMLElement) {
  function EdProductUpsells() {
    _classCallCheck(this, EdProductUpsells);
    return _callSuper(this, EdProductUpsells, arguments);
  }
  _inherits(EdProductUpsells, _HTMLElement);
  return _createClass(EdProductUpsells, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      if (!this.slider) return;
      this._attachListeners();
      this._updateStep();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.slider = this.querySelector('[id^="Slider-"]');
      this.buttons = this.querySelectorAll('[data-upsells-slider-button]');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;
      // Capture phase so the step is set before SliderComponent's own click handler runs.
      this.buttons.forEach(function (button) {
        button.addEventListener('click', _this._updateStep.bind(_this), true);
      });
      window.addEventListener('resize', this._updateStep.bind(this));
    }
  }, {
    key: "_updateStep",
    value: function _updateStep() {
      var step = this._getVisibleSlides();
      this.buttons.forEach(function (button) {
        button.dataset.step = step;
      });
    }
  }, {
    key: "_getVisibleSlides",
    value: function _getVisibleSlides() {
      var slides = Array.from(this.slider.querySelectorAll('[id^="Slide-"]'));
      if (slides.length < 2) return 1;
      var slideOffset = slides[1].offsetLeft - slides[0].offsetLeft;
      if (slideOffset <= 0) return 1;
      return Math.max(1, Math.floor(this.slider.clientWidth / slideOffset));
    }
  }]);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-product-upsells')) {
  customElements.define('ed-product-upsells', EdProductUpsells);
}

/***/ }),

/***/ "./src/js/modules/ed-right-action.js":
/*!*******************************************!*\
  !*** ./src/js/modules/ed-right-action.js ***!
  \*******************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var EdRightAction = /*#__PURE__*/function (_HTMLElement) {
  function EdRightAction() {
    _classCallCheck(this, EdRightAction);
    return _callSuper(this, EdRightAction, arguments);
  }
  _inherits(EdRightAction, _HTMLElement);
  return _createClass(EdRightAction, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.goTopButton = this.querySelector('#goTop');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      this.goTopButton.addEventListener('click', this.scrollToTop.bind(this));
    }
  }, {
    key: "scrollToTop",
    value: function scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }]);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-right-action', EdRightAction);

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
var __webpack_exports__ = {};
/*!**************************!*\
  !*** ./src/js/custom.js ***!
  \**************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _modules_ed_product_configurator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./modules/ed-product-configurator */ "./src/js/modules/ed-product-configurator.js");
/* harmony import */ var _modules_ed_product_tabs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./modules/ed-product-tabs */ "./src/js/modules/ed-product-tabs.js");
/* harmony import */ var _modules_ed_product_tabs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_product_tabs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _modules_ed_product_tab_dynamic_info__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./modules/ed-product-tab-dynamic-info */ "./src/js/modules/ed-product-tab-dynamic-info.js");
/* harmony import */ var _modules_ed_product_tab_dynamic_info__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_product_tab_dynamic_info__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _modules_ed_main_order__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./modules/ed-main-order */ "./src/js/modules/ed-main-order.js");
/* harmony import */ var _modules_ed_main_order__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_main_order__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _modules_ed_right_action__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./modules/ed-right-action */ "./src/js/modules/ed-right-action.js");
/* harmony import */ var _modules_ed_right_action__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_right_action__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _modules_ed_product_upsells__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./modules/ed-product-upsells */ "./src/js/modules/ed-product-upsells.js");
/* harmony import */ var _modules_ed_product_upsells__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_product_upsells__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _modules_ed_print_service_ed_print_service_form__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./modules/ed-print-service/ed-print-service-form */ "./src/js/modules/ed-print-service/ed-print-service-form.js");
/* harmony import */ var _modules_ed_print_service_ed_print_service_form__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_print_service_ed_print_service_form__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _modules_ed_print_service_ed_print_service_upload__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./modules/ed-print-service/ed-print-service-upload */ "./src/js/modules/ed-print-service/ed-print-service-upload.js");
/* harmony import */ var _modules_ed_print_service_ed_print_service_upload__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_print_service_ed_print_service_upload__WEBPACK_IMPORTED_MODULE_7__);
/*
DO NOT TOUCH THIS FILE OUTSIDE OF /src DIRECTORY
this file gets compiled ./assets/custom.js - make sure to import every module here.
*/









})();

// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
/*!******************************!*\
  !*** ./src/scss/custom.scss ***!
  \******************************/
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin

})();

/******/ })()
;